export enum BillingRecorrence {
	MONTHLY = "monthly",
	LOOSE = "loose",
}
